import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  const msg = 'Faltan las credenciales de Supabase en .env (REACT_APP_SUPABASE_URL y REACT_APP_SUPABASE_ANON_KEY)';
  console.error(msg);
  if (process.env.NODE_ENV === 'development') {
    throw new Error(msg);
  }
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseKey || 'placeholder',
  {
    auth: {
      persistSession: true,
      storage: localStorage,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);

// URL de redirección OAuth — usa el dominio actual con trailing slash para que Google
// y Supabase hagan match exacto con los Redirect URLs configurados
export const siteUrl = typeof window !== 'undefined'
  ? `${window.location.origin}/`
  : 'https://www.bryemma.com/';
